import { FC } from 'react';
import { DealDetails } from 'ts/package/interfaces/PackageDetails';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { getCurrency, formatPriceCurrency, openInNewWindow } from 'utils/utils';
import Rating from 'components/ui/Rating/Rating';
import { useSearchParams } from 'react-router-dom';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface SummaryDetailsProps {
  recommended: DealDetails[];
  mapUrl: string;
}

const SummaryDetails: FC<SummaryDetailsProps> = ({ recommended, mapUrl }) => {
  const [t] = useTranslation();
  const [urlParams] = useSearchParams();

  const onClickRecommended = (pac: DealDetails) => {
    const params = Object.fromEntries(urlParams);
    const data = {
      checkIn: params.checkIn,
      checkOut: params.checkOut,
      cityCode: params.cityCode.split('-')[0],
      dealId: pac.dealId,
      hotelId: pac.hotelId,
      type: params.type,
      provider: pac.provider,
      rowId: pac.rowId,
      isSale: 'false',
      paxComplect: pac.paxComplect,
      name: pac.rowName,
      searchToken: sessionStorage.getItem('searchPackagesToken')!,
    };

    openInNewWindow('/ILPackage/details?' + new URLSearchParams(data).toString());
  };
  return (
    <div className="package-summary">
      {mapUrl && (
        <div
          className="default-shadow package-summary-map"
          dangerouslySetInnerHTML={{ __html: mapUrl }}
        ></div>
      )}
      {false && (
        <div className="default-shadow flight-details-item">
          <div className="title-underline text-st mb-20">
            <FontAwesomeIcon icon={faLocationDot} className="mr-5" />
            {t('hotel.we_suggestion')}
          </div>
          {recommended.map((item, index) => (
            <div key={index} className="package-summary-suggestion">
              <div className="suggestion-img cur-poi" onClick={() => onClickRecommended(item)}>
                <img src={item.dealImage} alt="img" />
              </div>
              <div className="ml-10">
                <div
                  className="title text-sm text-cap text-contrast cur-poi mb-5"
                  onClick={() => onClickRecommended(item)}
                >
                  {item.rowName?.toLowerCase()}
                </div>
                <div className="mb-5">
                  <span className=" text-sm text-bold text-contrast">
                    {formatPriceCurrency(item.price, getCurrency(item.currency))}{' '}
                  </span>
                  <span className="text-xsm">{t('package.per_person')}</span>
                </div>
                {!!item.hotelRating && <Rating value={item.hotelRating} />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(SummaryDetails, 'SummaryDetails');
